import challengeConstants from '../actiontypes/challenge';

const initialState = {
  challenges: [],
  challengeResponse: "",
  isChallengeValid: false,
  isBloqued: false,
  isExpired: false,
  errorInput: true,
  errorChallengeValidate: null,
  isSmsRequestValid: false,
  loading: false,
  errorMessage: ""

};

function challenge(state = initialState, action) {
  switch (action.type) {
    case challengeConstants.CHALLENGE_REQUEST:
      return {
        ...state
      };
    case challengeConstants.CHALLENGE_REQUEST_SUCCESS:
      return {
        ...state,
        challenges: action.payload
      };
    case challengeConstants.CHALLENGE_REQUEST_FAILURE:
      return {
        ...state,
        challenges: []
      };
    case challengeConstants.CHALLENGE_CLOSED:
      return {
        ...state,
        challenges: [],
        challengeResponse: "",
        isChallengeValid: false,
        isExpired: false,
        isBloqued: false,
        errorInput:true,
        errorChallengeValidate: null,
        isSmsRequestValid: false,
        errorMessage: ""
      };
    case challengeConstants.CHALLENGE_RESPONSE_CHANGED:
      return {
        ...state,
        challengeResponse: action.payload
      };
    case challengeConstants.CHALLENGE_VALIDATE:
      return {
        ...state,
        loading: true
      };
    case challengeConstants.CHALLENGE_VALIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        isBloqued: action.payload.bloqueado,
        isChallengeValid: action.payload.valido,
        errorInput: !action.payload.valido && action.payload.bloqueado,
        challenges: action.payload.valido ? [] : [...state.challenges]
      };
    
    case challengeConstants.CHALLENGE_VALIDATE_FAILURE:
      return {
        ...state,
        loading: false,
        errorChallengeValidate: action.payload
      };

    case challengeConstants.CHALLENGE_REQUEST_SMS_SUCCESS:
      return {
        ...state,
        isSmsRequestValid: true
      };
    case challengeConstants.CHALLENGE_REQUEST_SMS_FAILURE:
      return {
        ...state,
        isSmsRequestValid: false
      };
    case challengeConstants.CHALLENGE_VALIDATE_SMS_SUCCESS:
      return {
        ...state,
        loading: false,
        isExpired: action.payload.expirado,
        isBloqued: action.payload.bloqueado,
        isChallengeValid: action.payload.valido,
        errorInput: !action.payload.valido && (action.payload.expirado || action.payload.bloqueado),
        challenges: action.payload.valido ? [] : [...state.challenges]
      };
    case challengeConstants.CHALLENGE_INVALID:
      return {
        ...state,
        errorInput: true
      }
    case challengeConstants.CHALLENGE_ERROR_MESSAGE_CHANGED:
      return {
        ...state,
        errorMessage: action.payload
      }
    default:
      return state;
  }
}

export default challenge;
